import 'slick-carousel';

export default function reviewsSlider() {

  const isDesktop = window.matchMedia('(min-width: 967px)').matches;
  const $reviewsSliderEl = $('.js-reviews-slider');
  const $reviewsSliderThumbsWrap = $('.js-reviews-slider-thumbs');
  const hasDesktopDots = $reviewsSliderEl.attr('data-desktop-dots') === 'true';
  const hasDesktopArrows = $reviewsSliderEl.attr('data-desktop-arrows') === 'true';

  function moveRetailersSliderLine(currentSlide) {
    const currentThumb = $reviewsSliderThumbsWrap.find('img').eq(currentSlide);
    const $line = $('.cmp-active-slide-line');
    const thumbWidth = currentThumb.width();
    $line.width(thumbWidth);

    if (thumbWidth) {
      const position = $(currentThumb).position();
      const translateX = position.left + parseInt($(currentThumb).css('marginLeft'), 10);
      $line.css('transform', `translateX(${translateX}px)`);
    }
  }

  function initRetailersSliderLine(currentSlide) {
    if (isDesktop) {
      $reviewsSliderThumbsWrap.append('<div class="cmp-active-slide-line"></div>');
      moveRetailersSliderLine(currentSlide);
    }
  }

  if ($reviewsSliderEl) {
    const thumbImages = $reviewsSliderThumbsWrap.find('img');

    $reviewsSliderEl.on('init', (event, slick) => {
      if (isDesktop) {
        initRetailersSliderLine(slick.currentSlide);
      }
    });

    $reviewsSliderEl.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 8000,
      dots: hasDesktopDots,
      arrows: hasDesktopArrows,
      responsive: [
        {
          breakpoint: 967,
          settings: {
            dots: true,
            arrows: false,
            adaptiveHeight: true,
          }
        }
      ]
    });

    $reviewsSliderEl.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      if (isDesktop) {
        moveRetailersSliderLine(nextSlide);
      }
    });

    thumbImages.each((index, el) => {
      $(el).on('click', () => {
        $reviewsSliderEl.slick('slickGoTo', index);
      });
    });


    if (isDesktop) {
      $(window).on('resize', () => {
        $reviewsSliderEl.slick('slickGoTo', 0);
      });
    }
  }
}
